import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
// Import the SessionService we fixed earlier
import { SessionService } from './services/session.service'; 
import { AuthService } from './services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const session = inject(SessionService); 
  const router = inject(Router);
  const authService = inject(AuthService);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true; // Allow rendering on the server, actual auth check happens on the client
  }

  if (authService.isLoggedIn()) {
    return true; 
  }

  router.navigate(['/login']);
  return false;
};